// Any "map" of values with a String key
export interface StringKeyed<T = any> {
    [key: string]: T;
}

// Any "map" of values with a numeric key
export interface NumberKeyed<T> {
    [key: number]: T;
}

export type Pair<L, R = L> = [L, R];

export function PairOf<L, R>(left: L, right: R): Pair<L, R> {
    return [left, right];
}

export type PrimitiveType = string | boolean | number;

export type Constructor<T> = new(...args: any[]) => T;

export type Consumer<T> = (value: T) => void;

export type Callable<T> = () => T;

export type Comparator<T> = (a: T, b: T) => number;

export type Predicate<T> = (value: T) => boolean;

export type Equality<T> = (a: T, b: T) => boolean;

export function DefaultEquality<T>(): Equality<T> {
    return (a, b) => a === b;
}

export type Transform<T, R> = (value: T) => R;

export type UnaryTransform<T> = Transform<T, T>;
